/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeePersonalDetails } from './EmployeePersonalDetails';
import {
    EmployeePersonalDetailsFromJSON,
    EmployeePersonalDetailsFromJSONTyped,
    EmployeePersonalDetailsToJSON,
    EmployeePersonalDetailsToJSONTyped,
} from './EmployeePersonalDetails';

/**
 * 
 * @export
 * @interface UpdateEmployeePersonalDetailsResponse
 */
export interface UpdateEmployeePersonalDetailsResponse {
    /**
     * 
     * @type {EmployeePersonalDetails}
     * @memberof UpdateEmployeePersonalDetailsResponse
     */
    data: EmployeePersonalDetails;
}

/**
 * Check if a given object implements the UpdateEmployeePersonalDetailsResponse interface.
 */
export function instanceOfUpdateEmployeePersonalDetailsResponse(value: object): value is UpdateEmployeePersonalDetailsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateEmployeePersonalDetailsResponseFromJSON(json: any): UpdateEmployeePersonalDetailsResponse {
    return UpdateEmployeePersonalDetailsResponseFromJSONTyped(json, false);
}

export function UpdateEmployeePersonalDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmployeePersonalDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeePersonalDetailsFromJSON(json['data']),
    };
}

  export function UpdateEmployeePersonalDetailsResponseToJSON(json: any): UpdateEmployeePersonalDetailsResponse {
      return UpdateEmployeePersonalDetailsResponseToJSONTyped(json, false);
  }

  export function UpdateEmployeePersonalDetailsResponseToJSONTyped(value?: UpdateEmployeePersonalDetailsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeePersonalDetailsToJSON(value['data']),
    };
}

